module.exports = __webpack_public_path__ + "img/srajan.6cf2efb8.png";